import { __assign } from "tslib";
import React, { forwardRef, useId, useMemo } from 'react';
import { AGORAPP_URL } from '../types/config';
export var EmbeddedEditor = forwardRef(function EmbeddedEditor(_a, ref2) {
    var aspectRatio = _a.aspectRatio, brand = _a.brand, hideTheory = _a.hideTheory, courseSlug = _a.courseSlug, lessonSlug = _a.lessonSlug, style = _a.style;
    var id = useId();
    var iframeCss = aspectRatio
        ? {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
        }
        : {};
    var containerCss = useMemo(function () {
        switch (aspectRatio) {
            case '16:9':
                return { paddingTop: '56.25%', height: 'auto' };
            case '4:3':
                return { paddingTop: '75%', height: 'auto' };
            case '3:2':
                return { paddingTop: '66.66%', height: 'auto' };
            case '1:1':
                return { paddingTop: '100%', height: 'auto' };
        }
        return {};
    }, [aspectRatio]);
    var iframeParams = useMemo(function () {
        var p = new URLSearchParams();
        if (brand) {
            p.append('brand', brand);
        }
        if (hideTheory) {
            p.append('hideTheory', '1');
        }
        return p;
    }, [brand, hideTheory]);
    var src = "".concat(AGORAPP_URL, "/editor2/").concat(courseSlug, "/").concat(lessonSlug, "?").concat(iframeParams.toString());
    src = "".concat(AGORAPP_URL, "/ide-embed/solidity/optimized-array-sum?hideTheory=1&brand=rare-skills&id=").concat(id);
    return (React.createElement("div", { style: __assign(__assign({ width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }, containerCss), style) },
        React.createElement("iframe", { title: 'AgorApp Web3 IDE', ref: ref2, src: src, allowFullScreen: true, id: id, style: __assign({ width: '100%', height: '100%', minWidth: '300px', minHeight: '300px', border: 'none' }, iframeCss) })));
});
//# sourceMappingURL=EmbeddedEditor.js.map